import React from "react";
import { Container, Table } from "react-bootstrap";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import bannerImage from "../../Images/about/dignatory_banner.webp";

const Faculty = () => {
  return (
    <React.Fragment>
      <Topnav />

      {/* Hero Banner */}
     <section
        className="section-hero-banner ptb-50"
        style={{
          backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
        }}
      >
        <div className="banner-hero-overlay">
          <div className="container-xxl">
            <div className="section-hero-content">
              <h1>Faculty</h1>
              <ol className="breadcrumb mt-3 text-center mb-0">
                <li className="breadcrumb-item">
                  <a href="/" style={{ color: "#fff", textDecoration: "none" }}>
                    Home
                  </a>
                </li>
                <li
                  className="breadcrumb-item active text-white"
                  aria-current="page"
                >
                  Faculty
                </li>
                <hr className="section-divider" />
              </ol>
            </div>
          </div>
        </div>
      </section>

      {/* Faculty Table */}
      <section className="ptb-50">
       <div className="container-xxl">
          <Table striped bordered hover responsive className="shadow text-start">
            <thead className="bg-primary text-white">
              <tr>
                <th className=" text-start">Name of Faculty</th>
                <th className=" text-start">Designation</th>
                <th className=" text-start">Department</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>MR RAMESHWAR NISHAD</td>
                <td>Assistant Professor</td>
                <td>Botany</td>
              </tr>
              <tr>
                <td>MR LUKESHWAR KUMAR</td>
                <td>Assistant Professor</td>
                <td>Botany</td>
              </tr>
              <tr>
                <td>DR. POONAM VERMA</td>
                <td>Assistant Professor</td>
                <td>Botany</td>
              </tr>
              <tr>
                <td>DR. RAJESH KUMAR</td>
                <td>Associate Professor</td>
                <td>Botany</td>
              </tr>
              <tr>
                <td>Dr. PRAKASH CHAND SAHU</td>
                <td>Assistant Professor</td>
                <td>Botany</td>
              </tr>
              <tr>
                <td>MR NARESH DHRUW</td>
                <td>Assistant Professor</td>
                <td>Chemistry</td>
              </tr>
              <tr>
                <td>DR. SUSHREETA PATNAIK</td>
                <td>Associate Professor</td>
                <td>Chemistry</td>
              </tr>
              <tr>
                <td>DR. SARBESWAR MISHRA</td>
                <td>Professor</td>
                <td>Chemistry</td>
              </tr>
              <tr>
                <td>MS. LALITA SAHU</td>
                <td>Assistant Professor</td>
                <td>Chemistry</td>
              </tr>
              <tr>
                <td>MS. TWINKAL DEEPAK</td>
                <td>Assistant Professor</td>
                <td>Chemistry</td>
              </tr>
              <tr>
                <td>DR. RITA DEWANJEE</td>
                <td>Professor</td>
                <td>Computer Science &amp; Information Technology</td>
              </tr>
              <tr>
                <td>DR. DIWAKAR R. TRIPATHI</td>
                <td>Assistant Professor</td>
                <td>Computer Science &amp; Information Technology</td>
              </tr>
              <tr>
                <td>MR NUKESH SAHU</td>
                <td>Assistant Professor</td>
                <td>Computer Science &amp; Information Technology</td>
              </tr>
              <tr>
                <td>MR GOVINDA</td>
                <td>Assistant Professor</td>
                <td>Computer Science &amp; Information Technology</td>
              </tr>
              <tr>
                <td>MR DAMESHWAR SAHU</td>
                <td>Assistant Professor</td>
                <td>Computer Science &amp; Information Technology</td>
              </tr>
              <tr>
                <td>MS. HIMANSHI SAHU</td>
                <td>Assistant Professor</td>
                <td>Computer Science &amp; Information Technology</td>
              </tr>
              <tr>
                <td>MR LUKESH KUMAR THAKUR</td>
                <td>Assistant Professor</td>
                <td>Computer Science &amp; Information Technology</td>
              </tr>
              <tr>
                <td>DR. BADRI VISHAL PADAMWAR</td>
                <td>Professor</td>
                <td>Mathematics</td>
              </tr>
              <tr>
                <td>DR. MANISH KUMAR PANDEY</td>
                <td>Assistant Professor</td>
                <td>Mathematics</td>
              </tr>
              <tr>
                <td>DR. AKANKSHA DUBEY</td>
                <td>Associate Professor</td>
                <td>Mathematics</td>
              </tr>
              <tr>
                <td>MR HEMANT PANDEY</td>
                <td>Assistant Professor</td>
                <td>Mathematics</td>
              </tr>
              <tr>
                <td>MR SUNIL KUMAR</td>
                <td>Assistant Professor</td>
                <td>Mathematics</td>
              </tr>
              <tr>
                <td>MS. RANU VERMA</td>
                <td>Assistant Professor</td>
                <td>Mathematics</td>
              </tr>
              <tr>
                <td>DR. SUBHASHISH BISWAS</td>
                <td>Professor</td>
                <td>Mathematics</td>
              </tr>
              <tr>
                <td>DR. SANJAY PANDEY</td>
                <td>Professor</td>
                <td>Physics</td>
              </tr>
              <tr>
                <td>DR. O P VERMA</td>
                <td>Assistant Professor</td>
                <td>Physics</td>
              </tr>
              <tr>
                <td>MS. REKHA SAHU</td>
                <td>Assistant Professor</td>
                <td>Physics</td>
              </tr>
              <tr>
                <td>DR. P. VISVANATHAN</td>
                <td>Professor</td>
                <td>Zoology</td>
              </tr>
              <tr>
                <td>MR LAXMIKANT SINHA</td>
                <td>Assistant Professor</td>
                <td>Zoology</td>
              </tr>
              <tr>
                <td>DR. N. KUMAR SWAMY</td>
                <td>Professor</td>
                <td>Electrical Electronics Engineering</td>
              </tr>
              <tr>
                <td>DR. ABHA TAMRAKAR</td>
                <td>Assistant Professor</td>
                <td>Computer Science Engineering</td>
              </tr>
              <tr>
                <td>DR. ANKIT MISHRA</td>
                <td>Assistant Professor</td>
                <td>Electrical Electronics Engineering</td>
              </tr>
              <tr>
                <td>MR ABHIJEET RAMANI</td>
                <td>Assistant Professor</td>
                <td>Computer Science Engineering</td>
              </tr>
              <tr>
                <td>MR VAGESH KUMAR</td>
                <td>Assistant Professor</td>
                <td>Civil Engineering</td>
              </tr>
              <tr>
                <td>MR SANJEEV JANGDE</td>
                <td>Assistant Professor</td>
                <td>Civil Engineering</td>
              </tr>
              <tr>
                <td>MR TAKESHWAR KAUSHIK</td>
                <td>Assistant Professor</td>
                <td>Mechanical Engineering</td>
              </tr>
              <tr>
                <td>MR KHEMANSHU KUMAR SAHU</td>
                <td>Assistant Professor</td>
                <td>Mechanical Engineering</td>
              </tr>
              <tr>
                <td>MR DUSHYANT KUMAR YADAV</td>
                <td>Assistant Professor</td>
                <td>Electrical Electronics Engineering</td>
              </tr>
              <tr>
                <td>MR KRISHNA KUMAR SAHU</td>
                <td>Assistant Professor</td>
                <td>Political Science and Public Administration</td>
              </tr>
              <tr>
                <td>MR MOHIT RAM CHELAK</td>
                <td>Assistant Professor</td>
                <td>Political Science and Public Administration</td>
              </tr>
              <tr>
                <td>DR. ANITA KURRE</td>
                <td>Professor</td>
                <td>Sociology</td>
              </tr>
              <tr>
                <td>DR. ASHWANI SAHU</td>
                <td>Assistant Professor</td>
                <td>Sociology</td>
              </tr>
              <tr>
                <td>DR. YOGMAYA UPADHYAY</td>
                <td>Professor</td>
                <td>Sociology</td>
              </tr>
              <tr>
                <td>DR. GARIMA DIWAN</td>
                <td>Assistant Professor</td>
                <td>English</td>
              </tr>
              <tr>
                <td>DR. SHEFALI YATEEN JAIN</td>
                <td>Associate Professor</td>
                <td>English</td>
              </tr>
              <tr>
                <td>MR MUKUL THAKUR</td>
                <td>Assistant Professor</td>
                <td>English</td>
              </tr>
              <tr>
                <td>MR HARISH PRADHAN</td>
                <td>Assistant Professor</td>
                <td>English</td>
              </tr>
              <tr>
                <td>MR ASHOK KUMAR SAHU</td>
                <td>Assistant Professor</td>
                <td>English</td>
              </tr>
              <tr>
                <td>DR. SANDEEP KUMAR SAHU</td>
                <td>Associate Professor</td>
                <td>Geography</td>
              </tr>
              <tr>
                <td>DR. PRATIMA VISHWAKARMA</td>
                <td>Assistant Professor</td>
                <td>Geography</td>
              </tr>
              <tr>
                <td>MS. BHAMTI SAHU</td>
                <td>Assistant Professor</td>
                <td>Geography</td>
              </tr>
              <tr>
                <td>MR KISHOR KUMAR KATHAR</td>
                <td>Assistant Professor</td>
                <td>Geography</td>
              </tr>
              <tr>
                <td>DR. DIAMOND SAHU</td>
                <td>Assistant Professor</td>
                <td>Hindi</td>
              </tr>
              <tr>
                <td>DR. NIRAJ CHAUBEY</td>
                <td>Assistant Professor</td>
                <td>Hindi</td>
              </tr>
              <tr>
                <td>DR. KIRAN BALA PATEL</td>
                <td>Assistant Professor</td>
                <td>Hindi</td>
              </tr>
              <tr>
                <td>DR. DIWAKAR TIWARI</td>
                <td>Assistant Professor</td>
                <td>Hindi</td>
              </tr>
              <tr>
                <td>MR RAMESH KUMAR</td>
                <td>Assistant Professor</td>
                <td>Hindi</td>
              </tr>
              <tr>
                <td>DR. PREETAM SAHU</td>
                <td>Assistant Professor</td>
                <td>History &amp; archaeology</td>
              </tr>
              <tr>
                <td>MR RAJENDRA PRASAD GENDRE</td>
                <td>Assistant Professor</td>
                <td>Law</td>
              </tr>
              <tr>
                <td>DR. SHAMEEM AHMAD KHAN</td>
                <td>Associate Professor</td>
                <td>Law</td>
              </tr>
              <tr>
                <td>MS. AFROZ KURAISHI</td>
                <td>Assistant Professor</td>
                <td>Law</td>
              </tr>
              <tr>
                <td>MS. SUMEDHA TIWARI</td>
                <td>Assistant Professor</td>
                <td>Law</td>
              </tr>
              <tr>
                <td>MR AJAY KUMAR</td>
                <td>Assistant Professor</td>
                <td>Law</td>
              </tr>
              <tr>
                <td>MS. BHUNESHWARI</td>
                <td>Assistant Professor</td>
                <td>Law</td>
              </tr>
              <tr>
                <td>MR SHISHIR VYAS</td>
                <td>Assistant Professor</td>
                <td>Law</td>
              </tr>
              <tr>
                <td>MR SANDEEP GOKHALE</td>
                <td>Assistant Professor</td>
                <td>Law</td>
              </tr>
              <tr>
                <td>MR BHEEM SINGH</td>
                <td>Assistant Professor</td>
                <td>Law</td>
              </tr>
              <tr>
                <td>MS. HIMASHUTA SAHU</td>
                <td>Assistant Professor</td>
                <td>Law</td>
              </tr>
              <tr>
                <td>MR GAJENDRA KUMAR YADAW</td>
                <td>Assistant Professor</td>
                <td>Law</td>
              </tr>
              <tr>
                <td>MR AKASH GUPTA</td>
                <td>Assistant Professor</td>
                <td>Law</td>
              </tr>
              <tr>
                <td>MS. CHHAYANGI BALA MAHAMALA</td>
                <td>Assistant Professor</td>
                <td>Law</td>
              </tr>
              <tr>
                <td>MS. RAGINI SONI</td>
                <td>Assistant Professor</td>
                <td>Law</td>
              </tr>
              <tr>
                <td>MS. AISHWARYA R. L. SONI</td>
                <td>Assistant Professor</td>
                <td>Law</td>
              </tr>
              <tr>
                <td>DR. VIMLA SONA</td>
                <td>Assistant Professor</td>
                <td>Library &amp; Information Science</td>
              </tr>
              <tr>
                <td>DR. BIRENDRA KUMAR PADHEE</td>
                <td>Professor</td>
                <td>Library &amp; Information Science</td>
              </tr>
              <tr>
                <td>MS. NEELAM</td>
                <td>Assistant Professor</td>
                <td>Library &amp; Information Science</td>
              </tr>
              <tr>
                <td>DR. J. H. VYAS</td>
                <td>Professor</td>
                <td>Commerce &amp; Management</td>
              </tr>
              <tr>
                <td>DR. VANDANA KASHYAP</td>
                <td>Associate Professor</td>
                <td>Commerce &amp; Management</td>
              </tr>
              <tr>
                <td>DR. NIDHI GOENKA</td>
                <td>Associate Professor</td>
                <td>Commerce &amp; Management</td>
              </tr>
              <tr>
                <td>MS. KESHAR LATA SAHU</td>
                <td>Assistant Professor</td>
                <td>Commerce &amp; Management</td>
              </tr>
              <tr>
                <td>DR. IMRAN NADEEM SIDDIQUI</td>
                <td>Professor</td>
                <td>Commerce &amp; Management</td>
              </tr>
              <tr>
                <td>DR. SHANTANU S. BOSE</td>
                <td>Associate Professor</td>
                <td>Commerce &amp; Management</td>
              </tr>
              <tr>
                <td>MS. HEENA JAISINGHANI</td>
                <td>Assistant Professor</td>
                <td>Commerce &amp; Management</td>
              </tr>
              <tr>
                <td>MS. SIJI RENO</td>
                <td>Assistant Professor</td>
                <td>Commerce &amp; Management</td>
              </tr>
              <tr>
                <td>MR SHIDHARTH MISHRA</td>
                <td>Assistant Professor</td>
                <td>Commerce &amp; Management</td>
              </tr>
              <tr>
                <td>DR. JAY KUMAR DEWANGAN</td>
                <td>Professor</td>
                <td>Commerce &amp; Management</td>
              </tr>
              <tr>
                <td>MR ROHIT KUMAR SINHA</td>
                <td>Assistant Professor</td>
                <td>Commerce &amp; Management</td>
              </tr>
              <tr>
                <td>MSR. ISHA SAHU</td>
                <td>Assistant Professor</td>
                <td>Commerce &amp; Management</td>
              </tr>
              <tr>
                <td>MR KESHAV SAHU</td>
                <td>Assistant Professor</td>
                <td>Pharmacy</td>
              </tr>
              <tr>
                <td>MR HIRANAND DEWANGAN</td>
                <td>Assistant Professor</td>
                <td>Pharmacy</td>
              </tr>
              <tr>
                <td>MR VIKAS SAHU</td>
                <td>Assistant Professor</td>
                <td>Pharmacy</td>
              </tr>
              <tr>
                <td>MR BHISHAM SAHU</td>
                <td>Assistant Professor</td>
                <td>Pharmacy</td>
              </tr>
              <tr>
                <td>MR YUGAL KISHOR RAJPUT</td>
                <td>Assistant Professor</td>
                <td>Pharmacy</td>
              </tr>
              <tr>
                <td>MR ASHWANEE KUMAR SAHU</td>
                <td>Assistant Professor</td>
                <td>Pharmacy</td>
              </tr>
              <tr>
                <td>MR RAJENDRA KUMAR SAHU</td>
                <td>Assistant Professor</td>
                <td>Pharmacy</td>
              </tr>
              <tr>
                <td>MR CHANDRAKANT YADAV</td>
                <td>Assistant Professor</td>
                <td>Pharmacy</td>
              </tr>
              <tr>
                <td>MR AVINASH DEWANGAN</td>
                <td>Assistant Professor</td>
                <td>Pharmacy</td>
              </tr>
              <tr>
                <td>MR SHIKHAR MISHRA</td>
                <td>Assistant Professor</td>
                <td>Pharmacy</td>
              </tr>
              <tr>
                <td>MS. SUMAN VERMA</td>
                <td>Assistant Professor</td>
                <td>Pharmacy</td>
              </tr>
              <tr>
                <td>MS. PRATIBHA JAISWAL</td>
                <td>Assistant Professor</td>
                <td>Pharmacy</td>
              </tr>
              <tr>
                <td>MR SURENDRA</td>
                <td>Assistant Professor</td>
                <td>Pharmacy</td>
              </tr>
              <tr>
                <td>MR TRIVENDRA KU SAHU</td>
                <td>Assistant Professor</td>
                <td>Pharmacy</td>
              </tr>
              <tr>
                <td>DR. DINESHCHANDRA G DESAI</td>
                <td>Professor</td>
                <td>Pharmacy</td>
              </tr>
              <tr>
                <td>MR VIKASH KUMAR SAHU</td>
                <td>Assistant Professor</td>
                <td>Pharmacy</td>
              </tr>
              <tr>
                <td>MS. VENU SAHU</td>
                <td>Assistant Professor</td>
                <td>Pharmacy</td>
              </tr>
            </tbody>
          </Table>
        </div>
      </section>

      <Footer />
    </React.Fragment>
  );
};

export default Faculty;
